import { closeWebsocketConnect, openWebsocketConnect } from 'app/actions/websocket';
import { Helmet, Loader } from 'app/components';
// import http from 'app/services/http';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';

import routes from './routes';

export const Router = (props) => {
    const dispatch = useDispatch();
    const { isLoading } = props;
    // eslint-disable-next-line no-unused-vars
    const { session, secret } = useSelector((state) => state.session);
    const { status } = useSelector((state) => state.websocket);

    // Установить веб-сокет соединение.
    useEffect(() => {
        if (session) {
            if (status !== 'OPENED') {
                dispatch(openWebsocketConnect());
            }
        }

        return () => {
            if (session) {
                dispatch(closeWebsocketConnect());
            }
        };
    }, [session]);

    // Периодический keepalive по HTTP при видимой вкладке (каждые 15 минут)
    // useEffect(() => {
    //     if (!session) return;
    //     let timer = null;
    //     const tick = () => {
    //         if (document.visibilityState === 'visible') {
    //             http.activity('session_keepalive');
    //         }
    //     };
    //     tick();
    //     timer = setInterval(tick, 900000);
    //     return () => {
    //         if (timer) clearInterval(timer);
    //     };
    // }, [session]);

    // Показать прелоадер, пока проверяются данные сеанса пользователя.
    if (isLoading) {
        return <Route render={() => <Helmet component={Loader} />} />;
    }

    // Продолжите загрузку маршрутизатора и определите пути маршрутизации приложений.
    return (
        <Switch>
            {routes.map((route, key) => (
                <Route
                    key={key}
                    path={route.path}
                    exact={route.exact ?? false}
                    render={() => {
                        switch (route.auth) {
                            case 'optional':
                                return session ? (
                                    <Redirect to={{ pathname: [config.userRoles['OPERATOR_CHECKLIST'], config.userRoles['ADMIN_CHECKLIST'], config.userRoles['INSPECTOR_OPERATOR_CHECKLIST']].includes(session.role_id) ? '/checklist' : '/map' }} />
                                ) : (
                                    <route.layout>
                                        <Helmet component={route.component} {...route} />
                                    </route.layout>
                                );
                            case 'required':
                                return !!session && session.permissions.some((permission) => route.permissions.includes(permission)) ? (
                                    <route.layout>
                                        <Helmet component={route.component} {...route} />
                                    </route.layout>
                                ) : (
                                    <Redirect to={{ pathname: '/' }} />
                                );
                            default:
                                return <Helmet component={route.component} {...route} />;
                        }
                    }}
                />
            ))}
        </Switch>
    );
};

export default Router;
